@if (
  {
    productivityScore: productivityScore$ | async,
  };
  as data
) {
  <div class="d-flex">
    <div>
      <wilson-score-bar
        [widthPercentage]="data.productivityScore?.widthPercentage || 0"
        [backgroundColor]="data.productivityScore?.backgroundColor || ''"
      ></wilson-score-bar>
      <div class="text-secondary score-label">
        <span class="fw-normal">{{
          'page.shift_timeline.productivity_score' | translate
        }}</span>
      </div>
    </div>
    <div class="score-position">
      {{ data.productivityScore?.widthPercentage || 0 }}%
    </div>
  </div>
}
